import axios from 'axios';
import { toast } from 'sonner';
import i18n from '../i18n';
import { config } from './config';

const API_URL = config.BACKEND_URL.replace(/\/$/, '') + '/api';

const API = axios.create({
    baseURL: API_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'x-xsrf-token',
});

API.interceptors.request.use((config) => {
    if (config.data instanceof FormData) {
        const h = config.headers;
        if (h && typeof (h as { delete?: (name: string) => void }).delete === 'function') {
            (h as { delete: (name: string) => void }).delete('Content-Type');
            (h as { delete: (name: string) => void }).delete('content-type');
        } else if (h && typeof h === 'object') {
            delete (h as Record<string, unknown>)['Content-Type'];
            delete (h as Record<string, unknown>)['content-type'];
        }
    }
    return config;
});

API.interceptors.response.use(
    (response) => response,
    (error) => {
        if (axios.isAxiosError(error) && error.response?.status === 429) {
            toast.error(i18n.t('errors.tooManyRequests'));
        }
        return Promise.reject(error);
    },
);

export default API;
export {API_URL};
